export enum AccessMode {
  WebsiteGuid = 'websiteGuid',
  Session = 'session'
}

export enum ViewMode {
  Interactive = 'interactive',
  RequestContact = 'requestContact',
  ForwardQuote = 'forwardQuote'
}

export const AppConstants = {
  Cookies: {
    VisitorGuid: 'visitor_guid'
  }
};
